const marketTests = [
    {
        "uuid": "1",
        "appNo": "A21100101",
        "customerNo": "0001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "product": "杏仁玄米餅",
        "status": "open",
        "activity": "marketTest_S10",
        "assignee": "王小華",
        "noSampling": false,
        "testCompany": "sgs",
        "paymentUnit": "tseyue",
        "source": "plan",
        "packingMethod": "glassBottle",
        "packagingSpec": ["360ml/瓶","1000ml/瓶"],
        "samplingLocation": "開心農場",
        "samplingDate": "2021-12-14T08:00:00.000Z",
        "effectiveDate": "2022-12-14T08:00:00.000Z",
        "samplingYear": 2021,
        "samplingSeason": "Q1",
        "marketTester": "劉阿南",
        "appStayDays": 2,
        "appProgress": "normal",
        "reviewResults": [
            {
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testResult": "unqualified",
                "reasonForUnqualified": "農藥殘留:賽滅寧0.5ppm(法規0.1ppm)",
            },
            {
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testResult": "qualified",
            },
            {
                "testItems":[{testItem:"09", details:["0901", "0903"]},{testItem:"10", details:["1002","1004"]}],
                "testResult": "qualified",
            },
        ]
    },
    {
        "uuid": "2",
        "appNo": "A21100102",
        "customerNo": "0002",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "台東廠",
        "product": "Pasta義大利麵",
        "status": "open",
        "activity": "marketTest_S20",
        "assignee": "吳小明",
        "noSampling": true,
        "changeSamplingYear": 2022,
        "changeSamplingSeason": "Q2",
        "descriptionForNoSampling": "原因......\n...................\n................",
        "source": "plan",
        "samplingYear": 2021,
        "samplingSeason": "Q2",
        "marketTester": "陳阿白",
        "appStayDays": 4,
        "appProgress": "normal",
        "reviewResults": [
            {
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testResult": "unqualified",
                "reasonForUnqualified": "農藥殘留:賽滅寧0.5ppm(法規0.1ppm)",
            },
            {
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testResult": "qualified",
            },
            {
                "testItems":[{testItem:"09", details:["0901", "0903"]},{testItem:"10", details:["1002","1004"]}],
                "testResult": "qualified",
            },
        ]
    },
    {
        "uuid": "3",
        "appNo": "A21100103",
        "customerNo": "0003",
        "customerName": "豆之家食品有限公司",
        "assessmentPlace": "台東廠",
        "product": "桂圓四物飲",
        "status": "close",
        "activity": "",
        "assignee": "",
        "noSampling": false,
        "testCompany": "sgs",
        "paymentUnit": "tseyue",
        "source": "plan",
        "packingMethod": "glassBottle",
        "packagingSpec": ["360ml/瓶","1000ml/瓶"],
        "samplingLocation": "開心農場",
        "samplingDate": "2021-12-14T08:00:00.000Z",
        "effectiveDate": "2022-12-14T08:00:00.000Z",
        "samplingYear": 2021,
        "samplingSeason": "Q3",
        "marketTester": "林阿嘉",
        "appStayDays": 3,
        "appProgress": "close",
        "reviewResults": [
            {
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testResult": "unqualified",
                "reasonForUnqualified": "農藥殘留:賽滅寧0.5ppm(法規0.1ppm)",
            },
            {
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testResult": "qualified",
            },
            {
                "testItems":[{testItem:"09", details:["0901", "0903"]},{testItem:"10", details:["1002","1004"]}],
                "testResult": "qualified",
            },
        ]
    },
]

export default marketTests;